import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, Inject, ViewEncapsulation } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Subscription, timer, throwError, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { SseService } from 'src/app/services/SseService';
import { BrokerService } from 'src/app/services/broker.services';
import { ibrkServices } from 'src/app/services/ibrk.service';
import { MetaApiService, METAAPI_REGIONES, MetaApiOrigen, MT5_GATEWAY_TOKEN, METAAPI_CLOUD_HABILITADO } from 'src/app/services/meta-api.service';
import { Mt5GatewayService, Mt5GatewayStatus, Mt5Terminal } from 'src/app/services/mt5-gateway.service';
import { ActivatedRoute, Router } from '@angular/router';
import { global } from 'src/app/global';
// Replaced MatSnackBar snackbar notifications with ToastrService where appropriate
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { OAuthService } from 'src/app/services/oauth.service';
import { Location } from '@angular/common';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { TablamercadoComponent } from '../../tablamercado/tablamercado.component';
import { all } from 'axios';
import { ToastrService } from 'ngx-toastr';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Suscripcion } from 'src/app/models/suscripcion';
import { BrokerAdapterFactory } from 'src/app/services/broker-adapter-factory.service';
import { LnaEstado, LocalNetworkPermissionService } from 'src/app/services/local-network-permission.service';
import { BrokerTabLockService } from 'src/app/services/broker-tab-lock.service';

@Component({
  selector: 'app-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrl: './login-dialog.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LoginDialogComponent implements OnDestroy, OnInit {
  @ViewChild(TablamercadoComponent) tablaMercado: TablamercadoComponent;
  public iniciando: boolean = false;
  public loading: boolean = true;
  public notificacion: boolean = false;
  public competingSessionWarned: boolean = false;
  public urlDelBackend: string;
  selectedTabIndex = 0; // índice del tab seleccionado

  public responseData: any;
  public intervalSubscription: Subscription | undefined;
  public suscripcionchekear: Subscription | undefined;
  public carterasBroker: any;
  public carteraSeleccionada: any;
  public logBroker: any;
  public connected: boolean = false;
  public authenticated: boolean = false;
  public suscribirseForm: boolean = false;
  public idModelo: number = 0;
  public periodo: number = 0;
  public metaApi: boolean = false;
  public metaApiAccountId: string = '';
  public idCartera: number = 0;
  token: any;
  modo: string;
  oauthToken: string | null = '';
  oauthVerifier: string | null = '';
  tipooauth: number = global.oauth.oauthTipo;

  @ViewChild('iframeRef') iframeRef: ElementRef | undefined;
  public urlstatus = '/iserver/auth/status';
  theme: string;
  accessToken: string = '';
  tokenSecret: string = '';
  myControl = new FormControl();
  cuentasBroker = ['NECTINVST-DEMO', 'NCTMINVST-LIVE'];
  cuentaSeleccionada = ''; // Variable para almacenar la cuenta seleccionada
  gwnoinstalado: boolean = true;

  // Permiso de Chrome "Acceso a la red local", necesario para llegar al Gateway en localhost
  lnaEstado: LnaEstado = 'unsupported';
  lnaPendiente: boolean = false; // el usuario ignoró o cerró el aviso del navegador
  private lnaStatus: PermissionStatus | null = null;
  private lnaOnChange = () => this.onLnaChange();

  get lnaBloqueaGateway(): boolean {
    return this.lnaEstado === 'denied' || this.lnaPendiente;
  }

  // MetaAPI
  metaApiToken: string = '';
  metaApiAccountInput: string = '';
  metaApiConectando: boolean = false;
  metaApiError: string = '';
  soloLoginMetaApi: boolean = false;

  // MetaAPI provisioning (create / saved accounts / deploy)
  metaApiMode: 'login' | 'crear' | 'manual' = 'login';
  mtLogin: string = '';
  mtPassword: string = '';
  mtServer: string = '';
  creandoCuenta: boolean = false;
  desplegando: boolean = false;
  deployError: string = '';
  deployMessage: string = 'Iniciando servidor MetaAPI...';
  cuentasGuardadasMetaApi: any[] = [];
  metaApiSelectedCuenta: any = null;
  /** Region to connect through; preselected with the account's region (tbl_metaapi_cuenta) */
  metaApiRegiones = METAAPI_REGIONES;
  regionLogin: string = '';
  /** True once the user picks a region by hand (e.g. the default one is unstable): it then wins over the account's region */
  regionLoginElegida = false;
  private autoCuentaIntentada: boolean = false;

  // MetaTrader por el Nectum MT5 Gateway local (misma REST que MetaAPI en https://localhost:8444)
  metaApiFuente: MetaApiOrigen = METAAPI_CLOUD_HABILITADO ? 'CLOUD' : 'GATEWAY';
  /** Login por MetaAPI en la nube: deshabilitado, MetaTrader solo se conecta por el Gateway local */
  readonly cloudHabilitado = METAAPI_CLOUD_HABILITADO;
  mt5GwEstado: Mt5GatewayStatus | null = null;
  mt5GwNoInstalado: boolean = false;
  mt5GwConectando: boolean = false;
  mt5GwError: string = '';
  mt5GwMostrarLogin: boolean = false;
  mt5GwLogin: string = '';
  mt5GwPassword: string = '';
  mt5GwServer: string = '';
  mt5GwIniciandoSesion: boolean = false;
  /** Terminales MT5 del equipo (con varios instalados, el usuario elige cuál usa el gateway) */
  mt5GwTerminales: Mt5Terminal[] = [];
  mt5GwCambiandoTerminal: boolean = false;
  /** Cuenta guardada (de la URL) a conectar en cuanto el gateway la tenga abierta */
  private mt5GwAutoConectar: string = '';
  /** Ya se intentó cambiar al terminal de la cuenta de la URL (no se reintenta en bucle) */
  private mt5GwAutoTerminalIntentado = false;
  private mt5GwPollId: any;

  private pollTimeoutId: any;

  get isMetaApiConnected(): boolean {
    return !!this.metaApiAccountInput;
  }

  /** Cuentas provisionadas en MetaAPI (las del gateway no ocupan servidores de la nube) */
  get cuentasCloudMetaApi(): any[] {
    return this.cuentasGuardadasMetaApi.filter(c => c?.origen !== 'GATEWAY');
  }

  public permisos: any = {};

  get ibkrPermitido(): boolean {
    return this.permisos?.ibkr?.status !== false;
  }

  get metapiPermitido(): boolean {
    return this.permisos?.metapi?.status !== false;
  }

  get metapiLimite(): number {
    return this.permisos?.metapi?.limite ?? 0;
  }

  get metapiLimiteAlcanzado(): boolean {
    return this.metapiLimite > 0 && this.cuentasCloudMetaApi.length >= this.metapiLimite;
  }

  /**
   * Sesión de MetaTrader 5 guardada en este navegador. A diferencia de isMetaApiConnected, que mira
   * el campo del formulario, esto mira las credenciales: es lo que impide iniciar sesión en IBKR,
   * porque la aplicación trabaja con un solo bróker activo.
   */
  get sesionMetaApiActiva(): boolean {
    return this.metaApiService.hasToken() && !!this.metaApiService.getAccountId();
  }

  /** Login de la cuenta MetaTrader activa; si no se guardó, el identificador de la cuenta. */
  get cuentaMetaApiActiva(): string {
    return localStorage.getItem('meta_api_account_login') || this.metaApiService.getAccountId();
  }

  constructor(private _httclient: HttpClient,private brokerAdapterFactory: BrokerAdapterFactory,
    public _cookieService: CookieService,
    private _sseService: SseService,
    private _brokService: BrokerService,
    public dialogRef: MatDialogRef<LoginDialogComponent>,
    private _ibrkService: ibrkServices,
    private _router: Router, private _route: ActivatedRoute,
    private toastr: ToastrService,
    public dialog: MatDialog, private oauthService: OAuthService, public location: Location,
    private metaApiService: MetaApiService,
    private mt5GatewayService: Mt5GatewayService,
    private lnaService: LocalNetworkPermissionService,
    private brokerTabLock: BrokerTabLockService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.urlDelBackend = 'http://localhost';
  }

  ngOnDestroy() {
    this.cerrarSubscription();
    this.cancelarPollingStatus();
    this.cancelarPollingMt5Gw();
    this.detenerVigilanciaLna();
  }
  onTab2Change(tab: any, event: MatTabChangeEvent): void {
    // No persistir el método aquí: iboauthmethod solo se guarda al confirmarse un login exitoso
    this.selectedTabIndex = event.index;
    this.cancelarPollingStatus();
    this.cancelarPollingMt5Gw();
    this.detenerVigilanciaLna();

    if (event.index === 0) {
      this.iniciargw();
    } else if (event.index === 1) {
      this.iniciaroauth();
    } else if (event.index === 2) {
      this.iniciarMetaApi();
    }
  }
  private cancelarPollingStatus(): void {
    if (this.suscripcionchekear && !this.suscripcionchekear.closed) {
      this.suscripcionchekear.unsubscribe();
    }
    if (this.pollTimeoutId) {
      clearTimeout(this.pollTimeoutId);
      this.pollTimeoutId = undefined;
    }
  }
  loginGateway() {
    //abrir ventana de login gateway
    const url = global.session.gwBaseUrlLogin;
    const windowFeatures = 'width=600,height=600,left=200,top=200';
    window.open(url, '_blank', windowFeatures);
  }
  loginOAuth() {
  }
  getOptions(endPoint: string) {
    const options = { ...global.credentials };
    options.useGw = global.session.useGw;
    if (endPoint) {
      options.endPoint = endPoint;
      options.url = global.session.baseUrl + endPoint;
      options.urlReal = global.session.baseUrlReal + endPoint;
    }
    return options;
  }
  onCuentaSeleccionada(cuenta: string): void {
    console.log('Cuenta seleccionada:', cuenta);
    this._cookieService.set("llave", cuenta.split('-')[0]);
  }
  compete() {
    this.iniciando = true;
    const locale = 'en_US';
    const tz = "xxx (America/New_York)";
    const url = '/iserver/auth/ssodh/init?publish=true&compete=' + true;
    const body = { locale, tz };
    // Forzar ruta OAuth: se ejecuta desde la pestaña OAuth antes de persistir el método
    this.oauthService.apiPostIbrk(url, body, '1').subscribe({
      next: (data: any) => {
        this.connected = data.connected;
        this.authenticated = data.authenticated;
        this.checkearStatus();

        this.iniciando = false;
      }, error: (error) => {
        this.toastr.error('Error al iniciar sesión: ' + error.message + ' Reintentar ', 'Error', { timeOut: 3000 });
        console.log("entre en firma ");
        this.iniciando = false;
      }
    });
  }
  async iniciargw() {
    console.log('iniciargw');

    if (this.data != null) {
    console.log('data no es null');
    console.log(this.data);
      this.idModelo = this.data.idModelo;
      this.idCartera = this.data.idCartera;
      this.token = this.data.token;
      this.suscribirseForm = this.data.suscribirseForm;
      this.metaApi = this.data.metaApi;
      this.modo = this.data.modo;
      this.periodo = this.data.periodo;
    }
    console.log('suscribirseForm' + this.suscribirseForm);
   // this.loginGateway();
    await this.vigilarPermisoLna();
    if (this.selectedTabIndex !== 0) return; // cambió de pestaña mientras se consultaba el permiso
    if (this.lnaEstado === 'denied') return; // sin permiso la petición a localhost falla siempre
    this.checkearStatus();
  }

  private async vigilarPermisoLna(): Promise<void> {
    this.detenerVigilanciaLna();
    this.lnaStatus = await this.lnaService.getStatus();
    this.lnaEstado = this.lnaStatus ? this.lnaStatus.state as LnaEstado : 'unsupported';
    this.lnaStatus?.addEventListener('change', this.lnaOnChange);
  }

  private detenerVigilanciaLna(): void {
    this.lnaStatus?.removeEventListener('change', this.lnaOnChange);
    this.lnaStatus = null;
  }

  private onLnaChange(): void {
    if (!this.lnaStatus) return;
    if (this.selectedTabIndex === 2 && this.metaApiFuente === 'GATEWAY') {
      // Mismo permiso del navegador para el gateway MT5 local
      this.lnaEstado = this.lnaStatus.state as LnaEstado;
      this.cancelarPollingMt5Gw();
      if (this.lnaEstado === 'denied') return;
      this.lnaPendiente = false;
      this.checkearMt5Gateway();
      return;
    }
    if (this.selectedTabIndex !== 0) return;
    this.lnaEstado = this.lnaStatus.state as LnaEstado;
    this.cancelarPollingStatus();
    if (this.lnaEstado === 'denied') return;
    // Permiso concedido (o restablecido) desde el aviso o el candado: reconectar sin recargar
    this.lnaPendiente = false;
    this.checkearStatus();
  }

  reintentarPermisoGateway(): void {
    if (this.lnaStatus) {
      this.lnaEstado = this.lnaStatus.state as LnaEstado;
    }
    if (this.lnaEstado === 'denied') {
      this.toastr.warning('El permiso sigue bloqueado. Habilítalo desde el icono a la izquierda de la dirección web.', 'Gateway', { timeOut: 5000 });
      return;
    }
    // Reintento tras un clic del usuario: si el permiso sigue en "preguntar", Chrome vuelve a mostrar el aviso
    this.lnaPendiente = false;
    this.cancelarPollingStatus();
    this.checkearStatus();
  }
  iniciaroauth() {
      if (this.data != null) {
        this.idModelo = this.data.idModelo;
        this.idCartera = this.data.idCartera;
        this.token = this.data.token;
        this.suscribirseForm = this.data.suscribirseForm;
        this.metaApi = this.data.metaApi;
        this.modo = this.data.modo;
        this.periodo = this.data.periodo;
      }
      console.log('suscribirseForm' + this.suscribirseForm);
      let temptoken = '';
      if (!this._cookieService.check('liveSessionToken')) {
        let urlretorno = window.location.protocol + '\\/\\/' + window.location.hostname + '/iboauth';

        if (window.location.hostname === 'localhost') {
          urlretorno = window.location.protocol + '\\/\\/' + window.location.hostname + ':20000/iboauth';
        }
        if (global.oauth.oauthTipo == 3) {
          // El backend firma el request token (la clave privada no esta en el navegador) y el
          // navegador lo envia a IBKR, como siempre.
          this.oauthService.pedirRequestToken(this._cookieService.get('llave'))
            .then((token: string) => {
              temptoken = token;
              if (!temptoken) {
                this.toastr.error('No se pudo iniciar la conexión con IBKR.', 'Broker');
                return;
              }

              let urloauth = 'https://www.interactivebrokers.com/authorize?oauth_token=' + temptoken + '&redirect_uri=' + urlretorno;

              window.open(urloauth, '_blank');
              window.open(urlretorno + '?oauth_token=' + temptoken, '_blank');
            })
            .catch((error: any) => {
              console.error(error);
              this.toastr.error(OAuthService.mensajeError(error, 'No se pudo iniciar la conexión con IBKR.'), 'Broker');
            });
        } else {
          let urlautoservicio = 'https://ndcdyn.interactivebrokers.com/sso/Login?action=OAUTH&RL=1&ip2loc=US';
          window.open(urlautoservicio, '_blank');
          //    window.open(urlretorno+'?oauth_token=' + temptoken, '_blank');
        }
      }
      this.checkearStatus();
  }
  iniciarMetaApi(): void {
    console.log(this.data);
    if (this.data != null) {
      this.idModelo = this.data.idModelo;
      this.idCartera = this.data.idCartera;
      this.token = this.data.token;
      this.suscribirseForm = this.data.suscribirseForm;
      this.modo = this.data.modo;
      this.metaApi = this.data.metaApi;
      this.soloLoginMetaApi = !!this.data.soloLoginMetaApi;
      this.periodo = this.data.periodo;
    }
    // Pre-fill saved credentials if they exist
    this.metaApiToken = this.metaApiService.getToken();
    this.regionLogin = this.metaApiService.getRegion();
    this.metaApiAccountInput = localStorage.getItem('metaapi_account_id') || '';
    // Fuente: la de la sesión activa; si no hay, la última elegida en este navegador
    this.metaApiFuente = !this.cloudHabilitado || this.metaApiService.isGateway() || localStorage.getItem('metaApiFuente') === 'GATEWAY'
      ? 'GATEWAY' : 'CLOUD';
    this.cargarCuentasGuardadas();
    if (this.metaApiFuente === 'GATEWAY') {
      this.iniciarMt5Gateway();
    }
  }

  conectarMetaApi(): void {
    if (!this.metaApiToken || !this.metaApiAccountInput) {
      this.metaApiError = 'Ingresa el token y el ID de cuenta.';
      return;
    }
    this.metaApiConectando = true;
    this.metaApiError = '';
    this.metaApiService.saveCredentials(this.metaApiToken, this.metaApiAccountInput);
    // Manual token: use the region picked by hand, else take it from the account's row if it is registered
    if (this.regionLoginElegida) this.metaApiService.setRegionUrl(this.regionLogin);
    const region$ = this.regionLoginElegida ? of(this.regionLogin) : this.metaApiService.syncRegionFromCuenta(this.metaApiAccountInput);
    region$.pipe(
      switchMap(() => this.metaApiService.verifyConnection(this.metaApiAccountInput, 0))
    ).subscribe({
      next: (ok: boolean) => {
        if (ok) {
          this.finalizarConexionMetaApi();
        } else {
          this.metaApiError = 'Token o cuenta inválidos. Verifica tus credenciales.';
          this.metaApiConectando = false;
        }
      },
      error: () => {
        this.metaApiError = 'Error de conexión con MetaAPI.';
        this.metaApiConectando = false;
      }
    });
  }

  private finalizarConexionMetaApi(): void {
    // Conexión MetaAPI verificada: único punto donde se persiste el método '2'
    localStorage.setItem('iboauthmethod', '2');
    if (this.soloLoginMetaApi) {
      this.metaApiConectando = false;
      this.desplegando = false;
      this.creandoCuenta = false;
      this.dialogRef.close({
        metaApiAuthenticated: true,
        accountId: this.metaApiAccountInput
      });
      return;
    }
    this.abrirCarteraMetaApi();
  }

  abrirCarteraMetaApi(): void {
    let token = this._cookieService.get('auth_token');

    // Obtener información de cuenta MetaAPI (balance, equity, margin, freeMargin)
            this.metaApiService.getAccountInformation(this.metaApiAccountInput).subscribe({
              next: (info: any) => {
                if (info) {
                  console.log(info);
                  const cuentasBrokerSuscritas: string[] = this.data?.cuentasBrokerSuscritas || [];
                  if (cuentasBrokerSuscritas.includes(String(info.login))) {
                    this.metaApiError = `La cuenta "${info.login}" ya está vinculada a otro modelo.`;
                    this.metaApiConectando = false;
                    return;
                  }
                  localStorage.setItem('meta_api_account_login', info.login);
                  const body = {
                    nombre: info.login,
                    metaapi: true,
                    metaApiAccountId: info.login
                  };
                  
                  this._sseService.apiPostNew('abrircarterabroker', body, token).subscribe({
                    next: (data: any) => {
                      this.metaApiConectando = false;
                      if (data?.status) {
                        if (this.suscribirseForm) {
                          // Modo vinculación: registrar la cuenta MetaAPI al modelo suscrito
                          this.carteraSeleccionada = info.login;
                          const wallet = {
                            ...data.cartera,
                            tipoBroker: 'METAAPI',
                            metaApiAccountId: this.metaApiAccountInput
                          };
                          this.sincronizarSymbolsCuenta(String(info.login), this.metaApiAccountInput, token, !!data?.nuevo);
                          this.suscribirse(wallet);
                        } else {
                          // Modo normal: abrir broker (si no vive ya en otra pestaña, que perdería su cartera)
                          this.brokerTabLock.isHeldElsewhere().then(enOtra => {
                            if (enOtra) {
                              this.avisarBrokerEnOtraPestana();
                              return;
                            }
                            this.abrirBrokerMetaApi(data, info.login, token);
                          });
                        }
                      } else {
                        this.metaApiError = data?.msg || 'Error al abrir la cartera.';
                      }
                    },
                    error: () => {
                      this.metaApiConectando = false;
                      this.metaApiError = 'Error al comunicarse con el servidor.';
                    }
                  });
                  }else{
                    this.toastr.error('No se pudo obtener la información de la cuenta MetaAPI. Verifica tus credenciales.', 'Error', { timeOut: 3000 });
                  }
              },
              error: (err: any) => console.warn('[MetaAPI] No se pudo obtener accountInformation', err)
            });
  }

  private abrirBrokerMetaApi(data: any, login: string, token: string): void {
    const wallet = {
      ...data.cartera,
      tipoBroker: 'METAAPI',
      metaApiAccountId: this.metaApiAccountInput
    };
    this._brokService.iniciadoTiempoReal = false;
    this._brokService.revisadosuscrito = false;
    this._brokService.updateBrokOptimaWallet(wallet);
    localStorage.setItem('idcarterabroker', data.cartera.idcartera);
    localStorage.setItem('idcartera', data.cartera.idcartera);
    this.metaApiConectando = false;
    this.dialogRef.close();
    this._router.navigate(['/broker'], { queryParams: { cuenta: login } });
    if (data?.nuevo) {
      const fuente = this.metaApiService.isGateway() ? 'Gateway MT5' : 'MetaAPI';
      this.toastr.success(`Cartera ${fuente} creada y abierta correctamente`, 'Éxito', { timeOut: 3000 });
      this.periodo = this.data?.periodo;
    }
    this.sincronizarSymbolsCuenta(login, this.metaApiAccountInput, token, !!data?.nuevo);
  }

  /**
   * Crea o completa la lista de activos de la cuenta (tbl_mercado con el login como nombre) con los
   * símbolos del bróker, por MetaAPI o por el gateway local. metaapi/symbols es idempotente, así que
   * se llama en cada conexión, como mucho una vez al día por cuenta (o siempre con una cartera nueva):
   * repara una lista ausente o incompleta y recoge los símbolos que el bróker añada.
   */
  private sincronizarSymbolsCuenta(login: string, accountId: string, token: string, forzar = false): void {
    if (!login || !accountId) return;
    const clave = 'metaapi_symbols_sync_' + accountId;
    const hoy = new Date().toISOString().slice(0, 10);
    if (!forzar && localStorage.getItem(clave) === hoy) return;
    this.metaApiService.getSymbols(accountId).subscribe({
      next: (symbols: any[]) => {
        // getSymbols devuelve [] si falla: no se crea una lista vacía y se reintenta en la próxima conexión
        if (!symbols?.length) {
          console.warn(`[MetaAPI] La cuenta ${login} no devolvió símbolos; se reintentará al reconectar`);
          return;
        }
        this._sseService.apiPostNew('metaapi/symbols', { accountId: login, metaApiAccountId: accountId, symbols }, token).subscribe({
          next: () => {
            localStorage.setItem('metaapi_symbols', JSON.stringify(symbols));
            localStorage.setItem(clave, hoy);
            console.log(`[MetaAPI] ${symbols.length} symbols loaded for account ${login}`);
          },
          error: (err) => console.warn('[MetaAPI] Could not save symbols', err)
        });
      },
      error: (err) => console.warn('[MetaAPI] Could not load symbols', err)
    });
  }

  private avisarBrokerEnOtraPestana(): void {
    this.metaApiConectando = false;
    this.toastr.error('El broker ya está abierto en otra pestaña', 'Broker', { timeOut: 5000 });
    this.dialogRef.close();
  }

  ngOnInit(): void {
    try {
      this.permisos = JSON.parse(this._cookieService.get('permisos') || '{}');
    } catch {
      this.permisos = {};
    }
    this.metaApiAccountId = localStorage.getItem('meta_api_account_login') || '';
    this.metaApi = this.data?.metaApi || false;
    this.theme = localStorage.getItem('theme') || 'light-theme';
    console.log('MetaAPI en LoginDialog: ', this.data);
    this.selectedTabIndex = parseInt(localStorage.getItem('iboauthmethod') || '0', 10);

    // If dialog was opened with metaApi=true, force tab 2 and skip IBKR init
    if (this.data?.metaApi) {
      this.selectedTabIndex = 2;
      this.iniciarMetaApi();
      return;
    }

    // Modelo no-MetaAPI: forzar IBKR e ignorar una preferencia MetaAPI heredada de otra sesión
    if (this.data?.suscribirseForm) {
      this.selectedTabIndex = localStorage.getItem('iboauthmethod') === '1' ? 1 : 0;
      if (this.selectedTabIndex === 1) {
        this.iniciaroauth();
      } else {
        this.iniciargw();
      }
      return;
    }

    let iboauthmethod = localStorage.getItem('iboauthmethod') ?? '0';

    // Cuenta en la URL: abrir la pestaña del broker al que pertenece, no la del último login
    const cuentaUrl = this.data?.cuenta ? String(this.data.cuenta) : '';
    if (cuentaUrl) {
      if (cuentaUrl === localStorage.getItem('meta_api_account_login')) {
        iboauthmethod = '2';
      } else if (cuentaUrl === localStorage.getItem('ultima_cuenta_broker') && iboauthmethod === '2') {
        iboauthmethod = '0';
      }
      this.selectedTabIndex = parseInt(iboauthmethod, 10);
    }

    if (iboauthmethod === '0') {
      this.iniciargw();
    }

    if (iboauthmethod === '1') {
      this.iniciaroauth();
    }

    if (iboauthmethod === '2') {
      this.iniciarMetaApi();
    }
    //limpiar todas las cookies
  }

  /**
   * El backend firma (con las claves privadas del consumer), el navegador envia la peticion a IBKR
   * y el backend calcula y verifica el LST con la respuesta. Aqui solo se guarda el LST resultante.
   */
  public getlivesesssiontoken() {
    this._cookieService.set('accessToken', this.accessToken);

    this.oauthService.generarLiveSessionToken(this._cookieService.get('llave'), this.accessToken, this.tokenSecret)
      .then((lst: string) => {
        global.credentials.liveSessionToken = lst;
        this._cookieService.set('liveSessionToken', lst);
      })
      .catch((error: any) => {
        this.toastr.error(OAuthService.mensajeError(error, 'No se pudo generar la sesión con IBKR.'), 'Broker');
      });
  }
  checkearStatus() {
    if (this.selectedTabIndex === 2) return; // MetaAPI activo — no llamar endpoints IBKR
    // El método candidato es la pestaña activa; solo se persiste al confirmarse la sesión
    const metodo = this.selectedTabIndex === 1 ? '1' : '0';
    this.suscripcionchekear =  this.oauthService.apiGetIbrk(this.urlstatus, metodo).subscribe({
      next: (data: any) => {
        this.gwnoinstalado = false;
        this.lnaPendiente = false;
        if (data) { // Verifica si data no es null o undefined
          this.responseData = data;
          //console.log("ESTATUS ACTUAL DE SESION", this.responseData);
          this.connected = this.responseData.connected;
          this.authenticated = this.responseData.authenticated;
          if (this.responseData.authenticated === false) {
            //console.log("this.responseData: ", this.responseData);
            this.loading = !this.loading;
            this.notificacion = !this.notificacion;
            this.competingSessionWarned = false;
            this._cookieService.delete('auth_broker');
            //esperar 2 segundos y volver a llamar a checkearStatus
            this.pollTimeoutId = setTimeout(() => {
              this.checkearStatus();
            }, 2000);
          } else if (this.responseData.authenticated === true && this.responseData.connected === true) {
            //console.log("Sesión activa");
            // Login confirmado: único punto donde se persiste el método Gateway/OAuth
            this.competingSessionWarned = false;
            localStorage.setItem('iboauthmethod', metodo);
            this._cookieService.set('auth_broker', 'true');
            this.cargarCarteras();
            this.pollTimeoutId = setTimeout(() => {
              this.checkearStatus();
            }, 2000);
          } else if (this.responseData.competing === true) {
            if (!this.competingSessionWarned) {
              this.toastr.error('Ya existe una sesión de IBKR activa en otro dispositivo o pestaña.', 'Broker', { timeOut: 6000 });
              this.competingSessionWarned = true;
            }
            this.pollTimeoutId = setTimeout(() => {
              this.checkearStatus();
            }, 2000);
          }
        } else {
          // Manejo de caso cuando data es null (indica un error de CORS manejado)
          this._cookieService.delete('auth_broker');
          console.log("Error de CORS manejado. No se puede verificar el estado de la sesión.");
        }
      },
      error: (err) => {
        if(metodo === '1'){
          if (this._cookieService.get('liveSessionToken')) {
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
              width: '380px',
              height: '250px',
              panelClass: this.theme,
              data: {
                msj: 'Parece que hubo un error con el token, refresca la pagina y vuelve a intentar o haz click en aceptar para iniciar sesion de nuevo y renovar el token'
              }
            });
            dialogRef.afterClosed().subscribe(result => {
              console.log('El diálogo se cerró');
              if (result) {
                this._cookieService.delete('auth_broker');
                this._cookieService.delete('liveSessionToken');
                this._cookieService.delete('accessToken');
                this._cookieService.delete('diffieHellmanChallenge');
                this._cookieService.delete('oauthToken');
                this._cookieService.delete('oauthVerifier');
                this._cookieService.delete('prepend');
                this._cookieService.delete('tokenSecret');
                window.location.reload();
              }
            });
            console.error('Ocurrió un error:', err);
          }
        } else if(metodo === '0') {
          const lnaActual = this.lnaStatus?.state;
          if (err.status === 401) {
                    this.gwnoinstalado = false;
          } else if (err.status === 0 && (lnaActual === 'prompt' || lnaActual === 'denied')) {
            // Chrome no dejó llegar a localhost (aviso ignorado, cerrado o bloqueado).
            // No se re-intenta en bucle para no relanzar el aviso cada 2 s (Chrome lo auto-bloquea tras varios descartes);
            // se reanuda con el botón "Reintentar" o al cambiar el permiso (onLnaChange).
            this.lnaEstado = lnaActual;
            this.lnaPendiente = lnaActual === 'prompt';
            return;
          } else {
                      this.gwnoinstalado = true;
          }
        }
        this.pollTimeoutId = setTimeout(() => {
              this.checkearStatus();
            }, 2000);
      }
    });
  }

  cargarCarteras(retryCount: number = 0, maxRetries: number = 3) {
    //console.log("ENTRE EN METODO CARGAR WALLETS");
  //  this.loading = !this.loading;
    this.cerrarSubscription();
    this.oauthService.apiGetIbrk('/iserver/accounts').subscribe({
      next: (data: any) => {
        if (!data || Object.keys(data).length === 0) {
          if (retryCount < maxRetries) {
            console.log(`Intento ${retryCount + 1} de ${maxRetries}: Respuesta vacía, reintentando...`);
            // Esperar 1 segundo antes de reintentar
            setTimeout(() => {
              //mostrar notificaion en pantalla
              this.toastr.success('No se encontraron carteras, reintentando...', 'Información', { timeOut: 3000 });
              this.cargarCarteras(retryCount + 1, maxRetries);
            }, 1000);
            return;
          } else {
            console.log("Máximo de intentos alcanzado");
            this._cookieService.delete('auth_broker');
            this.loading = false;
            this.notificacion = true;
            return;
          }
        }

        if (data) {
//          console.log(data);
          this.carterasBroker = data.accounts;
          if (this.carterasBroker != undefined && this.carterasBroker.length > 0) {
            this.carterasBroker = this.carterasBroker.filter((cartera: any) => cartera !== 'All');
            this.loading = false;
            this.notificacion = false;

            // Auto-seleccionar cuenta si viene en los parámetros
            if (this.data?.cuenta) {
              //console.log('Auto-seleccionando cuenta:', this.data.cuenta);
              // Buscar la cuenta exacta o que empiece con el valor proporcionado
              const cuentaEncontrada = this.carterasBroker.find((c: string) => 
                c === this.data.cuenta || c.startsWith(this.data.cuenta)
              );
              
              if (cuentaEncontrada) {
                this.carteraSeleccionada = cuentaEncontrada;
                this.cuentaSeleccionada = cuentaEncontrada;
                this.onCuentaSeleccionada(cuentaEncontrada);
                
                // Esperar un momento para que se establezca todo y luego abrir la cartera
                setTimeout(() => {
                  this.abrirCartera();
                }, 1000);
              } else {
                console.warn('Cuenta no encontrada en la lista de carteras:', this.data.cuenta);
              }
            } else {
              // Restaurar última cuenta seleccionada desde localStorage
              const ultimaCuenta = localStorage.getItem('ultima_cuenta_broker');
              if (ultimaCuenta) {
                const encontrada = this.carterasBroker.find((c: string) => c === ultimaCuenta);
                if (encontrada) this.carteraSeleccionada = encontrada;
              }
              if (!this.carteraSeleccionada) {
                this.carteraSeleccionada = this.carterasBroker[0];
              }
            }
          }
        } else {
          console.log("es null problema de cors", data);
          this._cookieService.delete('auth_broker');
        }
      }
    });
  }

  instalarGateway() {
    // poner enlace para descargar el gateway /agente/IBKRGatewayInstaller.exe
    const url = '/agente/IBKRGatewayInstaller.exe';
    const windowFeatures = 'width=600,height=600,left=200,top=200';
    window.open(url, '_blank', windowFeatures);
  }

  /**
   * Cierra la sesión de MetaTrader 5 y sigue con el login de IBKR de la pestaña activa.
   *
   * Simétrico a cerrarSesion(), que es la salida contraria (cerrar IBKR para entrar en MetaAPI).
   * Aquí NO se apaga el servidor de la cuenta: solo se cierra la sesión en este navegador, así que
   * volver a MetaAPI no obliga a esperar un despliegue.
   */
  cerrarSesionMetaApiParaIbkr(): void {
    const cuenta = this.cuentaMetaApiActiva;
    const confirmRef = this.dialog.open(ConfirmDialogComponent, {
      width: '420px',
      panelClass: this.theme,
      data: {
        titulo: 'Sesión MetaTrader 5 activa',
        icon: 'swap_horiz',
        msj: `Se cerrará la sesión de MetaTrader 5${cuenta ? ' (' + cuenta + ')' : ''} para poder iniciar sesión en Interactive Brokers.\n\n`
          + 'El servidor de la cuenta sigue encendido: podrá volver a MetaAPI sin esperar.',
        botonAceptar: 'Cerrar y continuar',
        destructivo: true
      }
    });

    confirmRef.afterClosed().subscribe(result => {
      if (!result) return;

      this._brokService.cerrarSesionMetaApiLocal();
      this.metaApiToken = '';
      this.metaApiAccountInput = '';
      this.metaApiAccountId = '';
      this.metaApiError = '';

      // Arrancar el flujo de la pestaña en la que está el usuario (0 = Gateway, 1 = OAuth).
      if (this.selectedTabIndex === 1) {
        this.iniciaroauth();
      } else {
        this.iniciargw();
      }
    });
  }

  cerrarSesion(): void {
    const confirmRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '250px',
      panelClass: this.theme,
      data: {
        msj: 'Esta Seguro de Cerrar Sesion en Broker? \n Debera volver a ingresar sus credenciales.'
      }
    });
    confirmRef.afterClosed().subscribe(result => {
      if (!result) return;
      if (localStorage.getItem('iboauthmethod') === '2') {
        const _undeployId = this.metaApiAccountInput || localStorage.getItem('metaapi_account_id') || '';
        // El gateway local no tiene servidor en la nube que apagar
        if (_undeployId && !this.metaApiService.isGateway()) {
          const _undeployToken = this._cookieService.get('auth_token');
          this._sseService.apiPostNew('metaapi/undeploy/' + _undeployId, {}, _undeployToken).subscribe();
        }
        this.metaApiService.clearCredentials();
        this.connected = false;
        this.authenticated = false;
        this.loading = true;
        this._brokService.updateBrokOptimaWallet(this._brokService.getDefaultWallet());
        this._brokService.updateBrokcompaniaMercado([]);
        this.dialogRef.close();
        //return;
      }
      this.oauthService.apiGetIbrk('/logout').subscribe({
        next: (data: any) => {
          if (data.status) {
            this._cookieService.delete('auth_broker');
            this._cookieService.delete('liveSessionToken');
            this._cookieService.delete('accessToken');
            this._cookieService.delete('diffieHellmanChallenge');
            this._cookieService.delete('oauthToken');
            this._cookieService.delete('oauthVerifier');
            this._cookieService.delete('prepend');
            this._cookieService.delete('tokenSecret');
            this.connected = false;
            this.authenticated = false;
            this.loading = true;
            this._brokService.updateBrokOptimaWallet(this._brokService.getDefaultWallet());
            this._brokService.updateBrokcompaniaMercado([]);
            this.dialogRef.close();
          }
        },
        error: () => {
          this.toastr.error('Error al cerrar sesión', 'Error', { timeOut: 3000 });
        }
      });
      //refrescar la pagina para ques se limpie todo y el usuario tenga que iniciar sesion de nuevo
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  }

  cerrarSubscription() {
    if (this.intervalSubscription && !this.intervalSubscription.closed) {
      console.log("se cierra subscripcion");
      this.intervalSubscription.unsubscribe();
    }
  }
  suscribirse(metaapiWallet?: any) {
    console.log('Suscribiéndose con cartera:', this.carteraSeleccionada, 'Modelo ID:', this.idModelo, 'Cartera ID:', this.idCartera, 'Periodo:', this.periodo);
    this._sseService.apiPostNew('suscripciones/registrarCuentaModelo', { nombre: this.carteraSeleccionada, idModelo: this.idModelo, idmercado: this.idCartera, periodo: this.periodo }, this.token).subscribe({
      next: (data: any) => {
        console.log(data);
        if (data.status) {
          this.toastr.success('La Cuenta ha sido vinculada', 'Éxito', { timeOut: 3000 });
          this.dialogRef.close(data.status);
        } else {
          this.toastr.error(data.msg || 'Error: revisar si esta cuenta de bróker está registrada en el sistema o si la cuenta esta suscrita a otro modelo.', 'Error', { timeOut: 3000 });

        }
      },
      complete: () => {
        setTimeout(async () => {
          // Tras vincular, no abrir /broker aquí si ya vive en otra pestaña (se pisaría su cartera)
          if (await this.brokerTabLock.isHeldElsewhere()) {
            this.avisarBrokerEnOtraPestana();
            return;
          }
          if (metaapiWallet) {
            // MetaAPI: establecer wallet y navegar sin pasar por IB Gateway
            this._brokService.iniciadoTiempoReal = false;
            this._brokService.revisadosuscrito = false;
            this._brokService.updateBrokOptimaWallet(metaapiWallet);
            localStorage.setItem('idcarterabroker', metaapiWallet.idcartera);
            localStorage.setItem('idcartera', metaapiWallet.idcartera);
            this._router.navigate(['/broker'], { queryParams: { cuenta: this.carteraSeleccionada } });
          } else {
            this.abrirCartera();
          }
        }, 2000);
      }
    });
  }
  async abrirCartera() {
    // Antes de cambiar la cuenta activa en IBKR (/iserver/account): /broker no debe vivir en otra pestaña
    if (await this.brokerTabLock.isHeldElsewhere()) {
      this.avisarBrokerEnOtraPestana();
      return;
    }
    let token = this._cookieService.get('auth_token');
    let jsonData = {
      nombre: this.carteraSeleccionada
    }
    console.log('modo ' + this.carteraSeleccionada);
    let cuenta = { "acctId": this.carteraSeleccionada };
    this.oauthService.apiPostIbrk('/iserver/account', cuenta).subscribe(data => {
      this._sseService.apiPostNew('abrircarterabroker', jsonData, token).subscribe({
        next: (data: any) => {
          console.log("ESTA ES LA REPUESTA DEL BACKEND: ", data);
          if (data.status) {
            this._brokService.iniciadoTiempoReal = false;
            this._brokService.revisadosuscrito = false;
            this._brokService.updateBrokOptimaWallet(data.cartera);
            console.log("ESTO TRAE  LA WALLETS: ", data.cartera.idcartera);
            localStorage.setItem('ultima_cuenta_broker', this.carteraSeleccionada);

            // Dejar la cuenta abierta en la URL (/broker?cuenta=DU149955), igual que MetaAPI: al
            // recargar, BrokerComponent la lee y reabre el login con esa cuenta.
            this._router.navigate(['/broker'], { queryParams: { cuenta: this.carteraSeleccionada } });
            localStorage.setItem('idcarterabroker', data.cartera.idcartera);
            localStorage.setItem('idcartera', data.cartera.idcartera);

          } else {
            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
              width: '380px',
              height: '250px',
              panelClass: this.theme,
              data: {
                msj: data.msg
              }
            });//AQUI VAMOS CON EL TEMA DE LA SESION EN BROKER EN DOS EQUIPOS DISTINTOS ConfirmDialogComponent ESTA DEMAS
            // Use Toastr instead of MatSnackBar
            this.toastr.error(data.msg || 'Error', 'Error', { timeOut: 30000, positionClass: 'toast-top-center' });
          }
        }
      });
    });
    this.dialogRef.close();
  }

  // =========================================================================
  // MetaAPI provisioning helpers
  // =========================================================================

  setMetaApiMode(mode: 'login' | 'crear' | 'manual'): void {
    this.metaApiMode = mode;
    this.metaApiError = '';
    this.deployError = '';
    localStorage.setItem('metaApiMode', mode);
  }

  cargarCuentasGuardadas(): void {
    const token = this._cookieService.get('auth_token');
    this._sseService.apiGetWithAuth('metaapi/cuentas-guardadas', token).subscribe({
      next: (data: any) => {
        if (data?.status) {
          this.cuentasGuardadasMetaApi = data.cuentas || [];
          const savedMode = localStorage.getItem('metaApiMode') as 'login' | 'crear' | 'manual' | null;
          if (this.cuentasCloudMetaApi.length > 0) {
            this.metaApiMode = savedMode ?? 'login';
            this.elegirCuentaGuardada(this.cuentasCloudMetaApi[0]);
          } else {
            this.metaApiMode = (savedMode === 'manual') ? 'manual' : 'crear';
          }
          this.autoConectarCuentaUrl();
        }
      },
      error: () => { /* silent — user may not have accounts yet */ }
    });
  }

  // Si el diálogo se abrió con una cuenta (p. ej. /broker?cuenta=...), conectarla sin esperar el clic
  private autoConectarCuentaUrl(): void {
    const cuenta = this.data?.cuenta;
    if (!cuenta || this.autoCuentaIntentada) return;
    const encontrada = this.cuentasGuardadasMetaApi.find((c: any) =>
      String(c.mtLogin) === String(cuenta) || c.metaApiAccountId === cuenta
    );
    if (!encontrada) {
      console.warn('Cuenta MetaAPI no encontrada entre las guardadas:', cuenta);
      return;
    }
    this.autoCuentaIntentada = true;
    if (encontrada.origen === 'GATEWAY') {
      // Cuenta del gateway local: se conecta en cuanto el gateway la tenga abierta en el terminal
      this.mt5GwAutoConectar = encontrada.metaApiAccountId;
      if (this.metaApiFuente !== 'GATEWAY') this.setMetaApiFuente('GATEWAY');
      return;
    }
    if (!this.cloudHabilitado) {
      this.mt5GwError = `La cuenta ${encontrada.mtLogin} es de MetaAPI (nube), que ya no está disponible. `
        + 'Ábrela en MetaTrader 5 y conéctala con el Gateway local.';
      return;
    }
    if (this.metaApiFuente !== 'CLOUD') this.setMetaApiFuente('CLOUD');
    this.metaApiMode = 'login';
    this.elegirCuentaGuardada(encontrada);
    this.seleccionarCuentaGuardada();
  }

  crearCuentaMetaApi(): void {
    if (this.metapiLimiteAlcanzado) {
      this.metaApiError = `Has alcanzado el límite de cuentas MetaAPI permitidas (${this.metapiLimite}).`;
      return;
    }
    if (!this.mtLogin || !this.mtPassword || !this.mtServer) {
      this.metaApiError = 'Ingresa el login, contraseña y servidor de MT5.';
      return;
    }
    this.creandoCuenta = true;
    this.metaApiError = '';
    this.deployError = '';
    const token = this._cookieService.get('auth_token');
    const body = { login: this.mtLogin, password: this.mtPassword, server: this.mtServer };
    this._sseService.apiPostNew('metaapi/crear-cuenta', body, token).subscribe({
      next: (data: any) => {
        if (data?.status) {
          if (data.yaExiste) {
            this.metaApiError = 'Esta cuenta ya está registrada. Conectando...';
          }
          const accountId = data.metaApiAccountId;
          const accountToken = data.accountToken || '';
          this.metaApiService.setOrigen('CLOUD');
          this.metaApiService.setRegionUrl(this.regionLoginElegida ? this.regionLogin : this.metaApiService.resolveRegion(accountId, data.region));
          this.metaApiAccountInput = accountId;
          this.metaApiService.saveCredentials(accountToken, accountId);
          this.deployYConectar(accountId, data.mtLogin || this.mtLogin);
        } else {
          this.metaApiError = data?.error || 'Error al crear la cuenta MetaAPI.';
          this.creandoCuenta = false;
        }
      },
      error: () => {
        this.metaApiError = 'Error de conexión al crear la cuenta.';
        this.creandoCuenta = false;
      }
    });
  }

  /** Selects a saved account and, unless a region was picked by hand, preselects its region. */
  elegirCuentaGuardada(cuenta: any): void {
    this.metaApiSelectedCuenta = cuenta;
    const region = this.metaApiService.resolveRegion(cuenta?.metaApiAccountId, cuenta?.region);
    if (!this.regionLoginElegida && region) {
      this.regionLogin = region;
    }
  }

  onRegionLoginChange(region: string): void {
    this.regionLogin = region;
    this.regionLoginElegida = true;
  }

  seleccionarCuentaGuardada(): void {
    if (!this.metaApiSelectedCuenta) {
      this.metaApiError = 'Selecciona una cuenta.';
      return;
    }
    const accountId = this.metaApiSelectedCuenta.metaApiAccountId;
    const accountToken = this.metaApiSelectedCuenta.accountToken || '';
    this.metaApiService.setOrigen('CLOUD');
    this.metaApiService.setRegionUrl(this.regionLoginElegida ? this.regionLogin : this.metaApiService.resolveRegion(accountId, this.metaApiSelectedCuenta.region));
    this.metaApiAccountInput = accountId;
    this.metaApiService.saveCredentials(accountToken, accountId);
    this.metaApiConectando = true;
    this.metaApiError = '';
    this.deployError = '';
    this.deployMessage = 'Iniciando servidor MetaAPI...';
    this.deployYConectar(accountId, this.metaApiSelectedCuenta.mtLogin);
  }

  deployYConectar(accountId: string, mtLogin: string): void {
    this.desplegando = true;
    this.deployError = '';
    const token = this._cookieService.get('auth_token');
    this._sseService.apiPostNew('metaapi/deploy/' + accountId, {}, token).subscribe({
      next: (data: any) => {
        if (data?.status) {
          this.pollEstadoDeploy(accountId, mtLogin, 0);
        } else {
          this.deployError = 'No se pudo iniciar el servidor MetaAPI.';
          this.desplegando = false;
          this.creandoCuenta = false;
          this.metaApiConectando = false;
        }
      },
      error: () => {
        this.deployError = 'Error al contactar el servidor.';
        this.desplegando = false;
        this.creandoCuenta = false;
        this.metaApiConectando = false;
      }
    });
  }

  private pollEstadoDeploy(accountId: string, mtLogin: string, intento: number, disconnectedCount: number = 0): void {
    const token = this._cookieService.get('auth_token');
    const MAX_INTENTOS = 100; // 100 × 3 s = 5 min máx
    if (intento >= MAX_INTENTOS) {
      this.deployError = 'El servidor tardó demasiado en conectar al broker. Verifica login, contraseña y nombre del servidor MT5.';
      this.desplegando = false;
      this.creandoCuenta = false;
      this.metaApiConectando = false;
      return;
    }
    setTimeout(() => {
      this._sseService.apiGetWithAuth('metaapi/estado/' + accountId, token).subscribe({
        next: (data: any) => {
          const state: string = (data?.state || '').toUpperCase();
          const connectionStatus: string = (data?.connectionStatus || '').toUpperCase();
          const apiMessage: string = data?.message || '';
          // Apply the correct region URL as soon as it is known, unless the user picked one by hand
          if (data?.region && !this.regionLoginElegida) {
            this.metaApiService.setRegionUrl(this.metaApiService.resolveRegion(accountId, data.region));
          }
          if (state === 'DEPLOY_FAILED') {
            this.deployError = apiMessage
              ? `El servidor MetaAPI falló: ${apiMessage}`
              : 'El servidor MetaAPI falló. Verifica las credenciales MT5.';
            this.desplegando = false;
            this.creandoCuenta = false;
            this.metaApiConectando = false;
          } else if (state === 'DEPLOYED' && connectionStatus === 'CONNECTED') {
            // Provisioning API reports connected — confirm Client API is also ready
            this.deployMessage = 'Verificando conexión con broker...';
            this.metaApiService.verifyConnection(accountId, 0).subscribe({
              next: (ok: boolean) => {
                if (ok) {
                  this.desplegando = false;
                  this.creandoCuenta = false;
                  this.finalizarConexionMetaApi();
                } else {
                  // Client API not ready yet, keep waiting
                  this.pollEstadoDeploy(accountId, mtLogin, intento + 1, 0);
                }
              },
              error: () => this.pollEstadoDeploy(accountId, mtLogin, intento + 1, 0)
            });
            return;
          } else if (state === 'DEPLOYED' && connectionStatus === 'DISCONNECTED') {
            const newDisconnCount = disconnectedCount + 1;
            if (newDisconnCount >= 10) {
              // ~30s of DISCONNECTED — guide the user
              const hint = apiMessage || 'Verifica que login, contraseña y servidor MT5 sean correctos.';
              this.deployMessage = `Conectando al broker MT5... (${hint})`;
            } else {
              this.deployMessage = 'Conectando al broker MT5...';
            }
            this.pollEstadoDeploy(accountId, mtLogin, intento + 1, newDisconnCount);
          } else if (state === 'DEPLOYED') {
            this.deployMessage = 'Conectando al broker MT5...';
            this.pollEstadoDeploy(accountId, mtLogin, intento + 1, disconnectedCount);
          } else {
            this.deployMessage = 'Iniciando servidor MetaAPI...';
            this.pollEstadoDeploy(accountId, mtLogin, intento + 1, disconnectedCount);
          }
        },
        error: () => this.pollEstadoDeploy(accountId, mtLogin, intento + 1, disconnectedCount)
      });
    }, 3000);
  }

  // =========================================================================
  // MetaTrader 5 por el Nectum MT5 Gateway local (mismo flujo que el Gateway de IBKR)
  // =========================================================================

  setMetaApiFuente(fuente: MetaApiOrigen): void {
    if (this.metaApiFuente === fuente || (fuente === 'CLOUD' && !this.cloudHabilitado)) return;
    this.metaApiFuente = fuente;
    this.metaApiError = '';
    this.mt5GwError = '';
    localStorage.setItem('metaApiFuente', fuente);
    this.cancelarPollingMt5Gw();
    this.detenerVigilanciaLna();
    if (fuente === 'GATEWAY') {
      this.iniciarMt5Gateway();
    }
  }

  async iniciarMt5Gateway(): Promise<void> {
    this.mt5GwError = '';
    await this.vigilarPermisoLna();
    if (this.selectedTabIndex !== 2 || this.metaApiFuente !== 'GATEWAY') return;
    if (this.lnaEstado === 'denied') return; // sin permiso la petición a localhost falla siempre
    this.checkearMt5Gateway();
  }

  private cancelarPollingMt5Gw(): void {
    if (this.mt5GwPollId) {
      clearTimeout(this.mt5GwPollId);
      this.mt5GwPollId = undefined;
    }
  }

  private programarMt5Gw(ms: number = 2000): void {
    this.cancelarPollingMt5Gw();
    this.mt5GwPollId = setTimeout(() => this.checkearMt5Gateway(), ms);
  }

  /** Sondea GET /gateway/status cada 2 s hasta que el terminal tiene una cuenta conectada. */
  checkearMt5Gateway(): void {
    if (this.selectedTabIndex !== 2 || this.metaApiFuente !== 'GATEWAY') return;
    this.mt5GatewayService.getStatus().subscribe({
      next: (estado: Mt5GatewayStatus) => {
        this.mt5GwNoInstalado = false;
        this.lnaPendiente = false;
        this.mt5GwEstado = estado;
        if (this.mt5GwTerminales.length === 0) this.cargarTerminalesMt5Gw();
        // Cuenta de la URL abierta en otro terminal del equipo: cambiar a ese terminal una vez
        if (this.mt5GwAutoConectar && estado.accountId !== this.mt5GwAutoConectar && !this.mt5GwAutoTerminalIntentado) {
          const destino = this.mt5GwTerminales.find(t => t.lastAccountId === this.mt5GwAutoConectar);
          if (destino) {
            this.mt5GwAutoTerminalIntentado = true;
            this.seleccionarTerminalMt5Gw(destino);
            return;
          }
        }
        if (estado.terminalConnected && estado.accountId) {
          if (this.mt5GwAutoConectar && this.mt5GwAutoConectar === estado.accountId && !this.mt5GwConectando) {
            this.mt5GwAutoConectar = '';
            this.conectarMt5Gateway();
            return;
          }
        } else if (estado.initialized && !estado.terminalConnected) {
          // Terminal abierto sin cuenta conectada: ofrecer iniciar sesión desde aquí
          this.mt5GwMostrarLogin = true;
        }
        if (!this.mt5GwConectando) this.programarMt5Gw();
      },
      error: (err: any) => {
        const lnaActual = this.lnaStatus?.state;
        this.mt5GwEstado = null;
        if (err?.status === 0 && (lnaActual === 'prompt' || lnaActual === 'denied')) {
          // Chrome no dejó llegar a localhost: no se reintenta en bucle (se relanzaría el aviso)
          this.lnaEstado = lnaActual;
          this.lnaPendiente = lnaActual === 'prompt';
          return;
        }
        this.mt5GwNoInstalado = true;
        this.programarMt5Gw(3000);
      }
    });
  }

  reintentarMt5Gateway(): void {
    if (this.lnaStatus) {
      this.lnaEstado = this.lnaStatus.state as LnaEstado;
    }
    if (this.lnaEstado === 'denied') {
      this.toastr.warning('El permiso sigue bloqueado. Habilítalo desde el icono a la izquierda de la dirección web.', 'Gateway MT5', { timeOut: 5000 });
      return;
    }
    this.lnaPendiente = false;
    this.checkearMt5Gateway();
  }

  cargarTerminalesMt5Gw(): void {
    this.mt5GatewayService.getTerminals().subscribe({
      next: (terminales: Mt5Terminal[]) => this.mt5GwTerminales = terminales || [],
      error: () => { /* gateway antiguo sin /gateway/terminals: se usa el terminal que tenga */ }
    });
  }

  /** Path del terminal activo, para el selector */
  get mt5GwTerminalActivo(): string {
    return this.mt5GwTerminales.find(t => t.active)?.path ?? '';
  }

  onTerminalMt5GwChange(path: string): void {
    const terminal = this.mt5GwTerminales.find(t => t.path === path);
    if (terminal && !terminal.active) this.seleccionarTerminalMt5Gw(terminal);
  }

  /**
   * Conecta el gateway al terminal elegido con su última cuenta (contraseña guardada en el terminal).
   * Si el terminal no tiene la contraseña, se ofrece el formulario de login con login y servidor rellenos.
   */
  seleccionarTerminalMt5Gw(terminal: Mt5Terminal): void {
    this.mt5GwCambiandoTerminal = true;
    this.mt5GwError = '';
    this.cancelarPollingMt5Gw();
    this.mt5GatewayService.selectTerminal(terminal.path, terminal.lastLogin, terminal.lastServer).subscribe({
      next: (estado: Mt5GatewayStatus) => {
        this.mt5GwCambiandoTerminal = false;
        this.mt5GwEstado = estado;
        this.mt5GwMostrarLogin = !estado.terminalConnected;
        this.cargarTerminalesMt5Gw();
        this.checkearMt5Gateway();
      },
      error: (err: any) => {
        this.mt5GwCambiandoTerminal = false;
        this.mt5GwError = err?.error?.message || `No se pudo conectar con ${terminal.name}.`;
        if (terminal.lastLogin) {
          this.mt5GwLogin = String(terminal.lastLogin);
          this.mt5GwServer = terminal.lastServer || '';
          this.mt5GwMostrarLogin = true;
        }
        this.cargarTerminalesMt5Gw();
        this.programarMt5Gw();
      }
    });
  }

  instalarMt5Gateway(): void {
    window.open(this.mt5GatewayService.installerUrl(), '_blank', 'width=600,height=600,left=200,top=200');
  }

  /** Inicia sesión en el terminal MT5 desde la web. Las credenciales solo van al gateway local. */
  iniciarSesionMt5Gateway(): void {
    if (!this.mt5GwLogin || !this.mt5GwPassword || !this.mt5GwServer) {
      this.mt5GwError = 'Ingresa el login, contraseña y servidor de MT5.';
      return;
    }
    this.mt5GwIniciandoSesion = true;
    this.mt5GwError = '';
    this.cancelarPollingMt5Gw();
    this.mt5GatewayService.login(this.mt5GwLogin, this.mt5GwPassword, this.mt5GwServer).subscribe({
      next: (estado: Mt5GatewayStatus) => {
        this.mt5GwIniciandoSesion = false;
        this.mt5GwPassword = '';
        this.mt5GwEstado = estado;
        this.mt5GwMostrarLogin = !estado.terminalConnected;
        this.programarMt5Gw();
      },
      error: (err: any) => {
        this.mt5GwIniciandoSesion = false;
        this.mt5GwError = err?.error?.message || 'No se pudo iniciar sesión en MetaTrader 5. Verifica login, contraseña y servidor.';
        this.programarMt5Gw();
      }
    });
  }

  /**
   * Conecta la cuenta abierta en el terminal: la registra en el backend (origen GATEWAY), apunta
   * MetaApiService al gateway y sigue el mismo camino que una cuenta MetaAPI ya desplegada.
   */
  conectarMt5Gateway(): void {
    const estado = this.mt5GwEstado;
    if (!estado?.terminalConnected || !estado.accountId || estado.login == null || !estado.server) {
      this.mt5GwError = 'Abre MetaTrader 5 e inicia sesión en tu cuenta para continuar.';
      return;
    }
    this.mt5GwConectando = true;
    this.metaApiConectando = true;
    this.mt5GwError = '';
    this.cancelarPollingMt5Gw();
    this.mt5GatewayService.registrarEnBackend(estado).subscribe({
      next: (data: any) => {
        if (!data?.status) {
          this.mt5GwConectando = false;
          this.metaApiConectando = false;
          this.mt5GwError = data?.error || 'No se pudo registrar la cuenta del gateway.';
          this.programarMt5Gw();
          return;
        }
        const accountId: string = data.metaApiAccountId || estado.accountId!;
        this.metaApiService.setOrigen('GATEWAY');
        this.metaApiService.saveCredentials(MT5_GATEWAY_TOKEN, accountId);
        this.metaApiAccountInput = accountId;
        this.metaApiService.verifyConnection(accountId, 0).subscribe({
          next: (ok: boolean) => {
            this.mt5GwConectando = false;
            if (ok) {
              this.finalizarConexionMetaApi();
            } else {
              this.metaApiConectando = false;
              this.mt5GwError = 'El gateway no devolvió la información de la cuenta. Revisa que MetaTrader 5 siga conectado.';
              this.programarMt5Gw();
            }
          },
          error: () => {
            this.mt5GwConectando = false;
            this.metaApiConectando = false;
            this.mt5GwError = 'Error de conexión con el gateway MT5.';
            this.programarMt5Gw();
          }
        });
      },
      error: (err: any) => {
        this.mt5GwConectando = false;
        this.metaApiConectando = false;
        this.mt5GwError = err?.error?.error || 'Error al registrar la cuenta del gateway.';
        this.programarMt5Gw();
      }
    });
  }

}
